import * as stream from 'getstream'
import { atom } from 'jotai'

export const rwStreamClientAtom = atom(
  stream.connect(
    process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' ? '3mp7zx9ygv93' : 'b2dm9w7r2z7w',
    process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
      ? 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoicHJvdWQtcmVzb25hbmNlLTgifQ._eUIU_ds-nDH--CIuB2MQ-W1DGAIaTPSMFvUIxX9rvo'
      : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoibU1iVDFRelhWM3pLQzJickdEdU1CZEF2ekU0UzUzVERkcEc3UDlQTWlCTCJ9.XX0Hw4R4YMbGhmaLpIHLEJwaRvV8UJ4fOEhbGui-laE',
    process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' ? '1178858' : '1179743'
  )
)
